"use client";

import { Search, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Input } from "@/components/ui/input";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterNavigationConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        <div className="h-5 w-24 bg-muted/30 animate-pulse rounded" />
        <div className="space-y-2">
          <div className="h-4 w-32 bg-muted/20 animate-pulse rounded" />
          <div className="h-4 w-28 bg-muted/20 animate-pulse rounded" />
          <div className="h-4 w-36 bg-muted/20 animate-pulse rounded" />
        </div>
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <div>
      <h4 className="text-lg font-semibold text-foreground-dark mb-4">Navigatie</h4>
      <ul className="space-y-2">
        {menuItems.map((item, i) => <li key={item.id} data-index={i}>
            <Link to={item.href || "#"} className="text-foreground-dark/80 hover:text-foreground-dark hover:underline transition-all duration-[var(--duration-fast)]">
              {item.label}
            </Link>
          </li>)}
      </ul>
    </div>;
}
export default function Footer() {
  const {
    ref: upperRef,
    isVisible: upperVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: lowerRef,
    isVisible: lowerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <footer className="w-full">
      {}
      <div ref={upperRef} className={`bg-background-dark py-16 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${upperVisible ? "opacity-100" : "opacity-0"}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {}
            <MenuProvider menu_id="4">
              <FooterNavigationConsumer />
            </MenuProvider>

            {}
            <div>
              <h4 className="text-lg font-semibold text-foreground-dark mb-4">Contact</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <svg className="size-5 text-secondary mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  <span className="text-foreground-dark/80 text-sm">Industriepark-West Sint-Niklaas</span>
                </li>
                <li className="flex items-center gap-3">
                  <svg className="size-5 text-secondary flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <Link to="tel:+3221234567" className="text-foreground-dark/80 hover:text-foreground-dark hover:underline transition-all duration-[var(--duration-fast)] text-sm">
                    0487412206
                  </Link>
                </li>
                <li className="flex items-center gap-3">
                  <svg className="size-5 text-secondary flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <Link to="mailto:info@ekonorm.be" className="text-foreground-dark/80 hover:text-foreground-dark hover:underline transition-all duration-[var(--duration-fast)] text-sm">
                    info@ekonorm.be
                  </Link>
                </li>
                <li className="flex items-center gap-3"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-file-text size-5 text-secondary flex-shrink-0" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:aiiwdy" data-ast-start="5572" data-ast-end="5632"><path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path><path d="M14 2v5a1 1 0 0 0 1 1h5"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg><span className="text-foreground-dark/80 text-sm" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:c0qjo3" data-ast-start="5651" data-ast-end="5793">BE1005102419</span></li>
              </ul>
            </div>

            {}
            <div>
              <h4 className="text-lg font-semibold text-foreground-dark mb-4">Zoeken</h4>
              <div className="relative">
                <Input type="search" placeholder="Zoek op de website..." className="w-full pr-10 bg-background-dark/50 border-border text-foreground-dark placeholder:text-foreground-dark/50" />
                <button type="button" className="absolute right-2 top-1/2 -translate-y-1/2 text-foreground-dark/60 hover:text-foreground-dark transition-colors duration-[var(--duration-fast)]" aria-label="Zoeken">
                  <Search className="size-4" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <div ref={lowerRef} className={`bg-[hsl(215,15%,16%)] py-6 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${lowerVisible ? "opacity-100" : "opacity-0"}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-dark/70 text-sm">
            © {new Date().getFullYear()} Ekonorm. Alle rechten voorbehouden.
          </p>
          <div className="flex items-center gap-3">
            <Link to="https://www.linkedin.com" newTab className="size-9 rounded-md bg-secondary/90 hover:bg-secondary flex items-center justify-center transition-all duration-[var(--duration-medium)] hover:-translate-y-1 hover:opacity-100 opacity-90" aria-label="LinkedIn">
              <svg className="size-5 text-foreground-secondary" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </Link>
            <Link to="https://www.youtube.com" newTab className="size-9 rounded-md bg-secondary/90 hover:bg-secondary flex items-center justify-center transition-all duration-[var(--duration-medium)] hover:-translate-y-1 hover:opacity-100 opacity-90" aria-label="YouTube">
              <svg className="size-5 text-foreground-secondary" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </Link>
            <Link to="https://www.pinterest.com" newTab className="size-9 rounded-md bg-secondary/90 hover:bg-secondary flex items-center justify-center transition-all duration-[var(--duration-medium)] hover:-translate-y-1 hover:opacity-100 opacity-90" aria-label="Pinterest">
              <svg className="size-5 text-foreground-secondary" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}